import {m} from 'framer-motion';
import {useTranslation} from 'react-i18next';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import {Theme, SxProps} from '@mui/material/styles';

import {ForbiddenIllustration} from 'src/assets/illustrations';

import {varBounce, MotionContainer} from 'src/minimal-components/animate';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  hasContent?: boolean;
  isAuthenticated?: boolean;
  email?: string;
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
};

export default function RoleBasedGuard({
  hasContent,
  isAuthenticated,
  email,
  children,
  sx
}: RoleBasedGuardProp) {
  // Logic here to get current user role
  // const {user} = useMockedUser();
  const {t} = useTranslation();

  // const currentRole = 'user';
  // const currentRole = user?.role; // admin;

  // if (isAuthenticated) {
  //   return hasContent ? (
  //     <Container component={MotionContainer} sx={{textAlign: 'center', ...sx}}>
  //       <m.div variants={varBounce().in}>
  //         <Typography variant="h3" sx={{mb: 2}}>
  //           Permission Denied
  //         </Typography>
  //       </m.div>

  //       <m.div variants={varBounce().in}>
  //         <Typography sx={{color: 'text.secondary'}}>
  //           You do not have permission to access this page
  //         </Typography>
  //       </m.div>

  //       <m.div variants={varBounce().in}>
  //         <ForbiddenIllustration
  //           sx={{
  //             height: 260,
  //             my: {xs: 5, sm: 10}
  //           }}
  //         />
  //       </m.div>
  //     </Container>
  //   ) : null;
  // }

  // return <> {children} </>;

  return isAuthenticated && hasContent ? (
    <Container component={MotionContainer} sx={{textAlign: 'center', ...sx}}>
      <m.div variants={varBounce().in}>
        <Typography variant="h3" sx={{mb: 2}}>
          Permission Denied
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <Typography sx={{color: 'text.secondary'}}>
          {t('You do not have permission to access this page!', {
            ns: 'private'
          })}
        </Typography>
        {email ? (
          <Typography sx={{color: 'text.secondary'}}>
            To request permission please email to{' '}
            <a href={`mailto:${email}`}>{email}</a>
          </Typography>
        ) : (
          <Typography sx={{color: 'text.secondary'}}>
            {t('Please contact your IT department.', {ns: 'private'})}
          </Typography>
        )}
      </m.div>

      <m.div variants={varBounce().in}>
        <ForbiddenIllustration
          sx={{
            height: 260,
            my: {xs: 5, sm: 10}
          }}
        />
      </m.div>
    </Container>
  ) : hasContent ? (
    <Container component={MotionContainer} sx={{textAlign: 'center', ...sx}}>
      <m.div variants={varBounce().in}>
        <Typography variant="h3" sx={{mb: 2}}>
          Permission Denied
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <Typography sx={{color: 'text.secondary'}}>
          You do not have permission to access this page
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <ForbiddenIllustration
          sx={{
            height: 260,
            my: {xs: 5, sm: 10}
          }}
        />
      </m.div>
    </Container>
  ) : null;
}
